<template>
<div class="component">

    <div class="filterHeader columns is-mobile is-multiline">
        <div class="column is-one-third-fullhd is-12-tablet is-12-mobile">
            <div class="columns is-mobile is-multiline">
                <span class="column is-6 has-text-right filterTitle">{{$t('enaq_translation_calendar_categorie')}}</span>
                <div class=" column is-6 has-text-left">
                    <div class="select">
                        <select v-model="selectedEventType">
                            <option value="-1">{{$t('enaq_translation_calendar_categorie_none')}}</option>

                            <option v-for="eventType in allEventTypes" :value="eventType.id">{{eventType.name}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="column is-one-third-fullhd is-12-tablet is-12-mobile">
            <div class="columns is-mobile is-multiline">
                <span class="column is-6 has-text-right  filterTitle">{{$t('enaq_translation_calendar_only_free')}}</span>
                <div class=" column is-6 has-text-left">

                    <slidebutton :height="'31px'" :default="onlyFree" @toggle="onlyFree = !onlyFree"></slidebutton>
                </div>
            </div>
        </div>
        <div class="column is-one-third-fullhd is-12-tablet is-12-mobile">
            <div class="columns is-mobile is-multiline">
                <span class="column is-6 has-text-right  filterTitle">{{$t('enaq_translation_calendar_only_open')}}</span>
                <div class=" column is-6 has-text-left">

                    <slidebutton :height="'31px'" :default="onlyOpen" @toggle="onlyOpen = !onlyOpen"></slidebutton>
                </div>
            </div>
        </div>
    </div>
    <Calendar @onChangeDate="onChangeDate" @onEventClick="onEventClick" :events="filteredEvents" :year="currentYear" :month="currentMonth"></Calendar>

    <div v-if="selectedEvent!=null" class="modal" :class="{'is-active':selectedEvent!=null}">
        <div class="modal-background" @click="selectedEvent=null"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">{{selectedEvent.title}}</p>
                <button @click="selectedEvent=null" class="delete" aria-label="close"></button>
            </header>
            <section class="modal-card-body">
                <div class="columns is-mobile is-multiline">

                    <div class="column is-2 hasBottomLine">{{$t('enaq_translation_calendar_event_organisator')}}</div>
                    <div class="column is-10  hasBottomLine">
                        <router-link class="" :to="{name:'messageCreateWithTitle',params:{messagetitle:'Eventanfrage zu '+selectedEvent.title,messagereciever:selectedEvent.author.id}}"> {{selectedEvent.author.firstname}} {{selectedEvent.author.name}} (Nachricht)
                        </router-link>

                    </div>
                    <div class="column is-2  hasBottomLine"> {{$t('enaq_translation_calendar_event_place')}} </div>
                    <div v-if="selectedEvent.place==null||selectedEvent.place==undefined||selectedEvent.place==''" class="column is-10 hasBottomLine">{{selectedEvent.room.name}}</div>
                    <div v-else class="column is-10  hasBottomLine">{{selectedEvent.place}}</div>

                    <div class="column is-12  hasBottomLine">

                        <div class="columns is-mobile is-multiline">
                            <div class="column is-2">{{$t('enaq_translation_calendar_event_date')}}</div>
                            <div class="column is-2 is-offset-3">
                                {{getReadableDate(selectedEvent.begin)}}
                            </div>
                            <div class="column is-2">{{getHour(selectedEvent.begin)}} {{$t('enaq_translation_calendar_event_date_hour')}}</div>
                            <div class="column is-1"> {{$t('enaq_translation_calendar_event_date_until')}} </div>
                            <div class="column is-2">{{getHour(selectedEvent.end)}} {{$t('enaq_translation_calendar_event_date_hour')}}</div>

                        </div>
                    </div>

                    <!--
                    <div class="column is-2">Am</div>
                    <div class="column is-10">
                        {{getReadableDate(selectedEvent.begin)}}
                    </div>

                    <div class="column is-2">Von</div>
                    <div class="column is-10">{{getHour(selectedEvent.begin)}} Uhr</div>

                    <div class="column is-2">Bis</div>
                    <div class="column is-10">{{getHour(selectedEvent.end)}} Uhr</div>
-->
                    <div class="column is-2 hasBottomLine">{{$t('enaq_translation_calendar_event_member')}}</div>
                    <div class="column is-10 hasBottomLine">
                        <span v-if="selectedEvent.maxMember==0||selectedEvent.maxMember==null">{{$t('enaq_translation_calendar_event_member_max')}}</span>
                        <span v-else>{{selectedEvent.membercount}} {{$t('enaq_translation_calendar_event_member_to')}} {{selectedEvent.maxMember}}</span>
                    </div>

                    <div class="column is-2 hasBottomLine">{{$t('enaq_translation_calendar_event_price')}}</div>
                    <div class="column is-10 hasBottomLine">
                        <span v-if="selectedEvent.price==0||selectedEvent.price==null">{{$t('enaq_translation_calendar_event_price_free')}}</span>
                        <span v-else>{{selectedEvent.price}} Euro</span>
                    </div>

                    <div class="column is-2 ">{{$t('enaq_translation_calendar_event_description')}}</div>
                    <div class="column is-10 "><span v-for="n in 1">{{selectedEvent.description}} </span></div>

                </div>
            </section>
            <footer class="modal-card-foot">
            <button class="button is-success" v-if="selectedEvent.organisator_id == $store.getters.getUser.id" @click="onEditEventClick()">{{$t('enaq_translation_calendar_event_change')}}</button>
                <button v-else-if="!selectedEvent.participated" class="button is-success" @click="participate()" :class="{'is-success':selectedEvent.membercount < selectedEvent.maxMember,'is-light':selectedEvent.membercount >= selectedEvent.maxMember}">{{$t('enaq_translation_calendar_event_participate')}}</button>
                <button v-else class="button is-success" @click="leave()" :class="{'is-success':selectedEvent.membercount < selectedEvent.maxMember,'is-light':selectedEvent.membercount >= selectedEvent.maxMember}">{{$t('enaq_translation_calendar_event_leave')}}</button>

                <button class="button" @click="selectedEvent=null">{{$t('enaq_translation_calendar_event_back')}}</button>
            </footer>
        </div>
    </div>

    <infoModal :message="infoMessage" :openModal="infoMessage!=''" :title="'Information'" @closed="infoMessage=''"></infoModal>

</div>
</template>

<script>
import Calendar from '@/components/Calendar/calendarMain'
import infoModal from '@/components/infoModal.vue';
import slidebutton from '@/components/helper/slidebutton.vue'

export default {
    name: 'Calendarview',
    components: {
        Calendar,
        infoModal,
        slidebutton,
    },
    props: [],
    mounted: function () {
        this.getEventTypes();
        this.getEvents();
    },
    data() {
        return {
            msg: 'Welcome to Your Vue.js App',
            data: [],
            currentMonth: 9,
            currentYear: 2019,
            events: [],
            participatedEvents: [],
            loaded: false,
            selectedEvent: null,
            infoMessage: "",
            allEventTypes: [],
            selectedEventType: -1,
            onlyFree: false,
            onlyOpen: false,

        }
    },
    methods: {
        onEventClick(event) {
            this.selectedEvent = event
        },
        onEditEventClick(){
        this.$router.push({name:'events',params: { eventtoedit: this.selectedEvent }})

        },
        onChangeDate(date) {

            this.currentMonth = new Date(date).getMonth() + 1;
            this.currentYear = new Date(date).getFullYear();
            this.getEvents();
        },
        getEvents() {
            this.events = []
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {
                year: this.currentYear + "",
                month: this.currentMonth + ""
            }
            this.$axios.post(this.$backendURL + "/events/get", postData, {
                headers: headerData
            }).then(function (result) {
                this.events = result.data.events
                this.getParticipatedEvents();
            }.bind(this))
        },

        getReadableDate(date) {
            let text = ""
            let dateObject = new Date(date)
            text += dateObject.getDate() + "." + (dateObject.getMonth() + 1) + "." + dateObject.getFullYear()

            return text;
        },
        getHour(date) {
            return new Date(date).getHours() + ""
        },
        getParticipatedEvents() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {
                year: this.currentYear + "",
                month: this.currentMonth + ""
            }
            this.$axios.get(this.$backendURL + "/events/participated", {
                headers: headerData
            }).then(function (result) {
                this.participatedEvents = result.data.participated

                for (var eventIndex = 0; eventIndex < this.events.length; eventIndex++) {
                    let eventData = this.events[eventIndex]
                    this.events[eventIndex].participated = false
                    if (this.checkIfParticipate(eventData)) {
                        this.events[eventIndex].color = "#4140FE"
                        this.events[eventIndex].participated = true

                    }

                }

                this.loaded = true;

            }.bind(this))
        },
        checkIfParticipate(event) {
            for (var participatedIndex = 0; participatedIndex < this.participatedEvents.length; participatedIndex++) {
                let partEvent = this.participatedEvents[participatedIndex];
                if (event.id == partEvent.id) {
                    return true;
                }
            }
            return false;
        },
        participate() {
            if (this.selectedEvent == null) {
                console.log("selected event is null")
                return;
            }
            if (this.selectedEvent.membercount >= this.selectedEvent.maxMember && this.selectedEvent.maxMember != 0 && this.selectedEvent.maxMember != null && this.selectedEvent.maxMember != undefined) {
                console.log("event is full")
                return;
            }

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {
                year: this.currentYear + "",
                month: this.currentMonth + ""
            }
            this.$axios.post(this.$backendURL + "/events/" + this.selectedEvent.id + "/join", postData, {
                headers: headerData
            }).then(function (result) {
                this.selectedEvent = null
                this.getEvents();
            }.bind(this))

        },
        leave() {
            if (this.selectedEvent == null) {
                console.log("selected event is null")
                return;
            }
            if (this.selectedEvent.membercount >= this.selectedEvent.maxMember && this.selectedEvent.maxMember != 0 && this.selectedEvent.maxMember != null && this.selectedEvent.maxMember != undefined) {
                console.log("event is full")
                return;
            }

            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            let postData = {
                year: this.currentYear + "",
                month: this.currentMonth + ""
            }
            this.$axios.post(this.$backendURL + "/events/" + this.selectedEvent.id + "/leave", postData, {
                headers: headerData
            }).then(function (result) {
                this.selectedEvent = null
                this.getEvents();
            }.bind(this))

        },
        getEventTypes() {
            let headerData = {
                'Accept': 'application/json',
                'Authorization': 'Bearer ' + localStorage.bearertoken
            }

            this.$axios.get(this.$backendURL + "/events/types", {
                headers: headerData
            }).then(function (result) {
                this.allEventTypes = result.data.eventTypes
            }.bind(this))
        },
    },
    computed: {

        filteredEvents() {

            var filteredEvents = this.events.filter(function (event) {

                if (this.selectedEventType != "" && this.selectedEventType != -1 && this.selectedEventType != undefined && this.selectedEventType != null) {
                    if (event.eventids == null || event.eventids.length <= 0 || !event.eventids.includes(this.selectedEventType)) {
                        return false;
                    }
                }

                if (this.onlyFree) {
                    if (event.price != null && event.price > 0 && event.price != undefined) {
                        return false
                    }
                }

                if (this.onlyOpen) {
                    if (new Date(event.begin) < new Date()) {
                        return false;
                    }

                    if (event.maxMember != null && event.maxMember > 0 && event.maxMember <= event.membercount) {
                        return false;
                    }
                    if (event.open == false || event.open == 0) {
                        return false;
                    }
                }

                return true
            }.bind(this));

            return filteredEvents;
        }
    },
}
</script>

<style scoped>
.filterHeader {
    margin-top: 20px;
}

.filterTitle {
    font-size: 1.5rem;
    font-weight: bolder;
}

.hasBottomLine {
    border-bottom: 1px solid #164786;
}
</style>
